"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.showErrorNotification = exports.errorNotificationTimeOut = void 0;
Object.defineProperty(exports, "translationKeys", {
    enumerable: true,
    get: function() {
        return _showErrorNotification.translationKeys;
    }
});
var _showErrorNotification = require("@ori-events/show-error-notification");
const errorNotificationTimeOut = exports.errorNotificationTimeOut = 3000;
const showErrorNotification = (message)=>window.dispatchEvent(new CustomEvent(_showErrorNotification.Name, {
        detail: {
            message: message !== null && message !== void 0 ? message : _showErrorNotification.translationKeys.genericError,
            notificationOptions: {
                delay: errorNotificationTimeOut
            }
        }
    }));
exports.showErrorNotification = showErrorNotification;
